module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesignCover.697f5a9e.jpeg";